export default __webpack_public_path__ + "static/media/telegram-i.205925a0.svg";